import { z } from 'zod';

export type AssignmentSummaryByPlayer = z.output<typeof assignmentSummaryByPlayerSchema>;
export type AssignmentSummaryByPlayerDTO = z.input<typeof assignmentSummaryByPlayerSchema>;

export const assignmentSummaryByPlayerSchema = z.object({
  playerId: z.string(),
  totalDuration: z.number(),
  totalShots: z.number(),
});

export type AssignmentSummaryBySession = z.output<typeof assignmentSummaryBySessionSchema>;
export type AssignmentSummaryBySessionDTO = z.input<typeof assignmentSummaryBySessionSchema>;

export const assignmentSummaryBySessionSchema = z.object({
  sessionId: z.string(),
  totalDuration: z.number(),
  totalShots: z.number(),
});
